import {Component, OnInit} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, Validators} from '@angular/forms';
import {AuthLoginService} from '../auth.service';
import {CPATTERN, ENUM_THEMES} from '../../shared/helpers/app.constants';
import {ToasterService} from '../../shared/services/toaster.service';
import { ThemesSettingsService } from '../../shared/services/themes-settings.service';

@Component({
  selector: 'app-forget-password',
  templateUrl: './forget-password.component.html',
  styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent implements OnInit {

  cvalidate = CPATTERN;
  loading: boolean = false;
  submitted: boolean = false;

  form: FormGroup;
  email: AbstractControl;
  
  isDarkTheme: boolean;

  constructor(private service: AuthLoginService,
              private toasterService: ToasterService,
              private themesSettingsService: ThemesSettingsService) {
    this.createForm();
  }

  ngOnInit() {
    const localData = this.themesSettingsService.getLocalStorage();
    if (localData && localData.themes === ENUM_THEMES.Dark) {
      this.isDarkTheme = true;
      if (document.body.classList.value.toString().indexOf('frac-dark-theme') === -1) document.body.classList.add('frac-dark-theme');
    } else {
      this.isDarkTheme = false;
      document.body.classList.remove('frac-dark-theme');
    }
  }

  createForm() {
    this.form = new FormGroup({
      email: new FormControl('', Validators.compose([Validators.required, Validators.pattern(this.cvalidate.EMAIL)])),
    });
    this.email = this.form.controls['email'];
  }

  onSubmit() {
    if (this.form.valid) {
      this.loading = true;
      this.submitted = true;
      const obj = this.form.value;
      this.service.forgetPassword(obj, () => {
        this.loading = false;
        this.submitted = false;
      })
        .subscribe(
          (response) => {
            this.toasterService.showSuccess('A reset password link will be sent via Email.');
            this.email.reset();
          }
        );
    }
  }

}
